import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
/* src/app/page.dashboard/view.scss: no such file or directory */`],
})
export class PageDashboardComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public summary: any = {};
    public feeStatus: any[] = [];
    public settlement: any[] = [];
    public categories: any = {};
    public recentUploads: any[] = [];
    public currentMonth: string = '';

    public async ngOnInit() {
        await this.service.init();
        this.currentMonth = this.getCurrentMonth();
        await this.load();
        await this.service.render();
    }

    public getCurrentMonth() {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    }

    public async load() {
        let res = await wiz.call("overview", { month: this.currentMonth });
        if (res.code === 200) {
            this.summary = res.data?.summary || {};
            this.feeStatus = res.data?.fee_status || [];
            this.settlement = res.data?.settlement || [];
            this.categories = res.data?.categories || {};
            this.recentUploads = res.data?.recent_uploads || [];
        }
        await this.service.render();
    }

    public getCategoryKeys() {
        return Object.keys(this.categories);
    }

    public paidCount() {
        return this.feeStatus.filter((f: any) => f.is_paid).length;
    }

    public unpaidCount() {
        return this.feeStatus.filter((f: any) => !f.is_paid).length;
    }
}

export default PageDashboardComponent;